module.exports = __webpack_public_path__ + "static/slider-perks-img4-7a128f78a42456fe28ba970c444aec64.jpeg";